import { render, staticRenderFns } from "./CourseContentTab.vue?vue&type=template&id=45aafdcd&scoped=true&"
import script from "./CourseContentTab.vue?vue&type=script&lang=js&"
export * from "./CourseContentTab.vue?vue&type=script&lang=js&"
import style0 from "./CourseContentTab.vue?vue&type=style&index=0&id=45aafdcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aafdcd",
  null
  
)

export default component.exports